<template>
  <v-container class="" grid-list-lg>
    <v-subheader class="px-0"
                 v-if="!searchInterestedUser && !searchInterestedCitizen"
    >
      {{ interesteds.length }} Interessados no Processo
      <v-menu offset-y>
        <v-btn
          slot="activator"
          color="blue"
          small
          flat
        >
          Adicionar
        </v-btn>
        <v-list>
          <v-list-tile @click="searchInterestedUser = true">
            <v-list-tile-title>Colaborador</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="searchInterestedCitizen = true">
            <v-list-tile-title>Cliente</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-subheader>

    <v-autocomplete
      v-if="searchInterestedUser"
      @change="addInterested($event, 'User')"
      @click:append="() =>{ searchInterestedUser = false; }"
      :items="availableUsers"
      :loading="loadingSearch"
      :search-input.sync="searchFieldUser"
      item-text="name"
      item-value="id"
      prepend-inner-icon="search"
      label="Buscar colaborador"
      append-icon="close"
      no-data-text="Nenhum colaborador encontrado"
      autofocus
      solo
    />

    <v-autocomplete
      v-if="searchInterestedCitizen"
      @change="addInterested($event, 'Citizen')"
      @click:append="() =>{ searchInterestedCitizen = false; }"
      :items="availableCitizens"
      :search-input.sync="searchFieldCitizen"
      :loading="loadingSearch"
      item-text="name"
      item-value="id"
      prepend-inner-icon="search"
      label="Buscar cliente"
      append-icon="close"
      no-data-text="Nenhum cliente encontrado"
      autofocus
      solo
    >
      <template slot="no-data">
        <v-layout
          column
          justify-center
          align-center
        >
          <span class="mt-3 text-xs-center">
            Nenhum cliente foi encontrado
          </span>
          <v-btn
            color="accent"
            flat
            @click="showNewCitizenDialog = true"
          >
            <v-icon left>mdi-plus</v-icon>
            Novo Cliente
          </v-btn>
        </v-layout>
      </template>
    </v-autocomplete>

    <v-layout row wrap class="px-2">
      <interested-card-list
        :interesteds="interesteds"
        @removeItem="removeInterested($event)"
      />
    </v-layout>
    <new-citizen-dialog
      :showNewCitizenDialog="showNewCitizenDialog"
      @newCitizenCallback="newCitizenCallback($event)"
    />
  </v-container>
</template>

<script>
  import { get, map } from 'lodash';
  import eventBus from '@/utils/event-bus';
  import foldersService from '@/services/FoldersService';

  import InterestedCardList from '@/components/folder/interested/list/InterestedCardList';
  import NewCitizenDialog from '@/components/folder/interested/new/NewCitizenDialog';

  import InterestedsService from "@/services/InterestedsService";

  export default {
    name: 'InterestedList',
    components: {
      InterestedCardList,
      NewCitizenDialog,
    },
    data() {
      return {
        searchInterestedUser: false,
        searchInterestedCitizen: false,

        searchFieldUser: '',
        searchFieldCitizen: '',

        showNewCitizenDialog: false,

        availableUsers: [],
        availableCitizens: [],
        interval: null,
        loadingSearch: false,
      };
    },
    computed: {
      interesteds() {
        const users = get(this.activeFolder, 'interesteds_users', [])
        const citizens = get(this.activeFolder, 'interesteds_citizens', [])
        return [...users, ...citizens];
      },
      activeFolder() {
        return this.$store.getters.activeFolder;
      },
      folderId() {
        return this.$store.getters.activeFolder.id;
      },
    },
    methods: {
      getFolder() {
        this.$store.dispatch('getActiveFolder', { id: this.folderId, loading: true });
      },
      searchUser(name) {
        if (name === '') return;

        InterestedsService
          .search(name, 'User')
          .then(({ data }) => {
            this.availableUsers = data;
          })
          .catch((err) => {
            this.onSearchError(err)
          })
          .finally(() => {
            this.loadingSearch = false;
          })

      },
      searchCitizen(name) {
        if (name === '') return;

        InterestedsService
          .search(name, 'Citizen')
          .then(({ data }) => {
            this.availableCitizens = data;
          })
          .catch(() => {
            this.onSearchError(err)
          })
          .finally(() => {
            this.loadingSearch = false;
          })
      },
      onSearchError(error) {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'error',
          message: error.response.data.join(', '),
          messageIcon: 'mdi-alert-outline',
        });
      },
      addInterested(id, type) {
        const payload = {
          interestable_id: id,
          interestable_type: type
        };
        foldersService
          .addInterested(this.folderId, payload)
          .then(() => {
            this.searchInterestedUser = false;
            this.searchInterestedCitizen = false;
            this.$store.dispatch('updateInteresteds', { folderId: this.folderId })

            this
              .$store
              .dispatch('toggleSnackbar', {
                show: true,
                color: 'success',
                message: 'Interessado adicionado com sucesso',
                button: { show: true, text: 'Fechar', message: '' },
                timeout: 6000,
              });
          })
          .catch(({ response }) => {
            this
              .$store
              .dispatch('toggleSnackbar', {
                show: true,
                color: 'error',
                message: response.data.join(', '),
                button: { show: true, text: 'Fechar', message: '' },
                timeout: 6000,
              });
          })
      },
      removeInterested(interestedId) {
        InterestedsService
          .destroy(interestedId)
          .then(() => {
            this
              .$store
              .dispatch('updateInteresteds', { folderId: this.folderId })

            this
              .$store
              .dispatch('toggleSnackbar', {
                show: true,
                color: 'success',
                message: 'Interessado removido com sucesso',
                button: { show: true, text: 'Fechar', message: '' },
                timeout: 6000,
              });
          })
          .catch(({ response }) => {
            this
              .$store
              .dispatch('toggleSnackbar', {
                show: true,
                color: 'error',
                message: response.data.join(', '),
                button: { show: true, text: 'Fechar', message: '' },
                timeout: 6000,
              });
          })
          .finally(() => {
            eventBus.$emit('stopLoadingRemoveInterested');
          });
      },
      newCitizenCallback(payload) {
        if (!payload) return;
        this.searchCitizen(payload.name)
      },
    },
    watch: {
      searchFieldUser(newValue) {
        if (newValue === null) return;

        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;
          this.searchUser(newValue)

        }, 500);
      },
      searchFieldCitizen(newValue) {

        if (!newValue) {
          return
        }
        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;

          this.searchCitizen(newValue);

        }, 500);
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/folder/interested/edit/InterestedList.vue